import { render, staticRenderFns } from "./TimeclockNotification.template.vue?vue&type=template&id=749a69a2&scoped=true&"
var script = {}
import style0 from "./TimeclockNotification.template.vue?vue&type=style&index=0&id=749a69a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749a69a2",
  null
  
)

export default component.exports